import { useState, useEffect, useCallback } from 'react';
export function useStickyDown(translateY) {
  const [sticky, setSticky] = useState(false);
  const handleNavigation = useCallback(() => {
    if (window.scrollY < 20) {
      setSticky(false);
    }
    if (window.scrollY > translateY) {
      // #87985 quick fix in order to fix page stuck
      const scrollHeight = document && document.documentElement ? document.documentElement.scrollHeight : 0;
      if (window.innerHeight > 900 && window.innerHeight < 1251 && scrollHeight > 1200 && scrollHeight < 1360) {
        setSticky(false);
      } else {
        setSticky(true);
      }
    }
  }, []);
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const mainNavElem = document.querySelector('.corp-main-nav');
    if (mainNavElem) {
      window.addEventListener('scroll', handleNavigation);
      return () => {
        window.removeEventListener('scroll', handleNavigation);
      };
    }
  }, [handleNavigation, translateY]);
  return sticky;
}